import React from "react";
import { Page, View, Text, StyleSheet, Image, Font } from "@react-pdf/renderer";

// Font registration
Font.register({
  family: "Roboto",
  fonts: [
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-400-normal.woff",
      fontWeight: "normal",
    },
    {
      src: "https://cdn.jsdelivr.net/npm/@fontsource/roboto/files/roboto-latin-700-normal.woff",
      fontWeight: "bold",
    },
  ],
});

Font.registerHyphenationCallback(word => [word]);

// Styles
const styles = StyleSheet.create({
  page: {
    padding: 25,
    fontFamily: "Roboto",
    position: "relative",
    paddingTop: 110,
    paddingBottom: 90,
  },
  logo2: {
    position: "absolute",
    top: 30,
    left: 30,
    width: 60,
  },
  upperDesign: {
    position: "absolute",
    top: -10,
    right: 0,
    width: 280,
    marginBottom: 80,
  },
  lowerDesign: {
    position: "absolute",
    bottom: -10,
    right: 0,
    width: 300,
    marginTop: "20px",
  },
  mainContent: {
    flex: 1,
    alignContent: "center",
    marginTop: 0,
    marginBottom: 0,
    paddingHorizontal: 40,
  },
  heading: {
    fontSize: 23,
    fontWeight: "bold",
    marginBottom: 10,
    borderBottomWidth: 2,
    borderBottomColor: "#000",
    borderBottomStyle: "solid",
    paddingBottom: 15,
    width: "100%",
  },
  paragraph: {
    fontSize: 17,
    lineHeight: 1.5,
    marginBottom: 30,
    marginTop: 15,
  },
  disclaimer: {
    fontSize: 14,
    lineHeight: 1.4,
    marginTop: 190,
  },
  pageNumber_Box: {
    position: "absolute",
    bottom: 20,
    left: 10,
    width: 25,
    height: 25,
    border: "2px solid orange",
    borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    zIndex: 2,
  },
  pageNumber: {
    fontSize: 11,
    color: "#000",
    textAlign: "center",
  },
});

const JourneyPagePDF = ({ assets, showPageNumber }) => (
  <Page size="A4" style={styles.page}>
    {/* Decorative images */}
    <Image src={assets.upper} style={styles.upperDesign} fixed />
    <Image src={assets.lower} style={styles.lowerDesign} fixed />
    <Image src={assets.logo2} style={styles.logo2} fixed />

    {/* Main content */}
    <View style={styles.mainContent}>
      <Text style={styles.heading}>Your Journey Begins Now!</Text>

      <Text style={styles.paragraph}>
        Career decisions take time and exploration. Keep learning about
        yourself, trying new things, and developing essential skills. Stay
        curious, keep experimenting, and remember that your career path is yours
        to create!
      </Text>

      <Text style={styles.disclaimer}>
        <Text style={{ fontWeight: "bold" }}>Disclaimer:</Text> This report is
        intended to provide general guidance and suggestions based on the
        results of the VIP test. While efforts have been made to ensure
        accuracy, the recommendations are not definitive predictions or
        guarantees of success. Achievement in any career requires individual
        action, effort, and skill development. Find Your True North disclaims
        any liability for decisions made based on this report. It is recommended
        to seek additional advice from education and career counseling
        professionals for further clarity.
      </Text>
    </View>

    {/* Footer - page number only */}
    <>
      {showPageNumber && (
        <View style={styles.pageNumber_Box}  fixed>
          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) => `${pageNumber}`}
            fixed
          />
        </View>
      )}
    </>
  </Page>
);

export default JourneyPagePDF;
